////// SPRITE CONFIGS //////

export const SCENE_SPRITE_CONFIGS = {
    crystal: {
        key: "crystal",
        spritesheet: "/sprites/scenes/crystal.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    blood_drops: {
        key: "blood_drops",
        spritesheet: '/sprites/combat/blood-drops.png',
        frameConfig: {
            frameWidth:32,
            frameHeight: 64
        }
    },
    healing_font: {
        key: "healing_font",
        spritesheet: '/sprites/combat/objects/healingfont.png',
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    chains_parallax: {
        key: "chains_parallax",
        spritesheet: '/sprites/combat/chains_parallax.png',
        frameConfig: {
            frameWidth: 1024,
            frameHeight: 192
        }
    },
    bricks_a: {
        key: "bricks_a",
        spritesheet: '/sprites/combat/objects/bricks/a.png',
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    bricks_b: {
        key: "bricks_b",
        spritesheet: '/sprites/combat/objects/bricks/b.png',
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    bricks_c: {
        key: "bricks_c",
        spritesheet: '/sprites/combat/objects/bricks/c.png',
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    bricks_d: {
        key: "bricks_d",
        spritesheet: '/sprites/combat/objects/bricks/d.png',
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
};

export const SCENE_ANIMATION_CONFIGS = {
    crystal: {
        key: "crystal",
        frames: {
            spriteKey: "crystal",
            frames: [0,1,2,3,4,5,6,7]
        },
        frameRate: 4,
        repeat: -1
    },
    blood_drops_dripping: {
        key: "blood_drops_dripping",
        frames: {
            spriteKey: "blood_drops",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 6,
        repeat: -1
    }
}

// Static sprite configs for all color variants
export const SOLAGOTCHI_SPRITE_CONFIGS = {
    solagotchi_yellow: {
        key: "solagotchi_yellow",
        spritesheet: "/sprites/solagotchi/solagotchi_yellow.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    solagotchi_black: {
        key: "solagotchi_black",
        spritesheet: "/sprites/solagotchi/solagotchi_black.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    solagotchi_blue: {
        key: "solagotchi_blue",
        spritesheet: "/sprites/solagotchi/solagotchi_blue.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    solagotchi_gray: {
        key: "solagotchi_gray",
        spritesheet: "/sprites/solagotchi/solagotchi_gray.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    solagotchi_purple: {
        key: "solagotchi_purple",
        spritesheet: "/sprites/solagotchi/solagotchi_purple.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
    solagotchi_red: {
        key: "solagotchi_red",
        spritesheet: "/sprites/solagotchi/solagotchi_red.png",
        frameConfig: {
            frameWidth: 32,
            frameHeight: 32
        }
    },
};

////// ANIMATION CONFIGS //////
// Function to generate animation configs for a specific color
const generateAnimationConfigs = (colorKey) => ({
    [`${colorKey}_static`]: {
        key: `${colorKey}_static`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [0]  // 1st row - 1 frame
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_idle1`]: {
        key: `${colorKey}_idle1`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [5, 6, 7, 8]  // 2nd row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_idle2`]: {
        key: `${colorKey}_idle2`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [10, 11, 12, 13, 14]  // 3rd row - 5 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_happy1`]: {
        key: `${colorKey}_happy1`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [15, 16, 17, 18]  // 4th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_happy2`]: {
        key: `${colorKey}_happy2`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [20, 21, 22, 23]  // 5th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_happy3`]: {
        key: `${colorKey}_happy3`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [25, 26, 27, 28]  // 6th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_happy4`]: {
        key: `${colorKey}_happy4`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [30, 31, 32, 33]  // 7th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_happy5`]: {
        key: `${colorKey}_happy5`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [35, 36, 37, 38]  // 8th row - 4 frames
        },
        frameRate: 4,
        repeat: -1
    },
    [`${colorKey}_cool`]: {
        key: `${colorKey}_cool`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [40, 41, 42, 43]  // 9th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_angry1`]: {
        key: `${colorKey}_angry1`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [45, 46, 47, 48]  // 10th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_angry2`]: {
        key: `${colorKey}_angry2`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [50, 51, 52, 53]  // 11th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_sad1`]: {
        key: `${colorKey}_sad1`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [55, 56, 57, 58]  // 12th row - 4 frames
        },
        frameRate: 3,
        repeat: -1
    },
    [`${colorKey}_tired1`]: {
        key: `${colorKey}_tired1`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [60, 61, 62, 63]  // 13th row - 4 frames
        },
        frameRate: 1,
        repeat: -1
    },
    [`${colorKey}_tired2`]: {
        key: `${colorKey}_tired2`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [65, 66, 67, 68]  // 14th row - 4 frames
        },
        frameRate: 1,
        repeat: -1
    },
    [`${colorKey}_tired3`]: {
        key: `${colorKey}_tired3`,
        frames: {
            spriteKey: `solagotchi_${colorKey}`,
            frames: [70, 71, 72, 73]  // 15th row - 4 frames
        },
        frameRate: 1,
        repeat: -1
    }
});

// Generate all animation configs for all colors
const COLORS = ['yellow', 'black', 'blue', 'gray', 'purple', 'red'];
export const SOLAGOTCHI_ANIMATION_CONFIGS = COLORS.reduce((configs, color) => {
    return { ...configs, ...generateAnimationConfigs(color) };
}, {});



export const PLOT_SIGN_SPRITE_CONFIGS = {
    plot_sign: {
        key: "plot_sign",
        spritesheet: "/sprites/farming/plot-sign.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 24
        }
    }
}

export const CHEST_SPRITE_CONFIGS = {
    chest: {
        key: "chest",
        spritesheet: "/sprites/chest2.png",
        frameConfig: {
            frameWidth: 24,
            frameHeight: 24
        }
    }
}

export const CHEST_ANIMATION_CONFIGS = {
    chest_horizontal_open: {
        key: "chest_horizontal_open",
        frames: {
            spriteKey: "chest",
            frames: [0,1,2,3,4]
        },
        frameRate: 8,
        repeat: 0
    },
    chest_horizontal_close: {
        key: "chest_horizontal_close",
        frames: {
            spriteKey: "chest",
            frames: [4,3,2,1,0]
        },
        frameRate: 8,
        repeat: 0
    },
    // chest_vertical_open: {
    //     key: "chest_vertical_open",
    //     frames: {
    //         spriteKey: "chest",
    //         frames: [5,6,7,8,9]
    //     },
    //     frameRate: 8,
    //     repeat: 0
    // },
    // chest_vertical_close: {
    //     key: "chest_vertical_close",
    //     frames: {
    //         spriteKey: "chest",
    //         frames: [9,8,7,6,5]
    //     },
    //     frameRate: 8,
    //     repeat: 0
    // }
}

export const PLOT_SIGN_ANIMATION_CONFIGS = {
    plot_sign_idle: {
        key: "plot_sign_idle",
        frames: {
            spriteKey: "plot_sign",
            frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]
        },
        frameRate: 4,
        repeat: -1
    }
}

export const STAT_SPRITE_CONFIGS = {
    health: {
        key: "health",
        spritesheet: "/sprites/solagotchi/health.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 15
        }
    },
    hunger: {
        key: "hunger",
        spritesheet: "/sprites/solagotchi/hunger.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 16
        }
    },
    energy: {
        key: "energy",
        spritesheet: "/sprites/solagotchi/energy.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 16
        }
    },
}

export const STAT_ANIMATION_CONFIGS = {
    health: {
        key: "health",
        frames: {
            spriteKey: "health",
            frames: [0,1,2,3,4,5,6,7]
        },
        frameRate: 3,
        repeat: -1
    },
    hunger: {
        key: "hunger",
        frames: {
            spriteKey: "hunger",
            frames: [0,1,2,3,4,5,6,7]
        },
        frameRate: 3,
        repeat: -1
    },
    energy: {
        key: "energy",
        frames: {
            spriteKey: "energy",
            frames: [0,1,2,3,4,5,6,7]
        },
        frameRate: 3,
        repeat: -1
    },
}

export const CROP_SPRITE_CONFIGS = {
    beans: {
        key: "beans",
        spritesheet: "/sprites/items/consumables/farming/beans.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    beet: {
        key: "beet",
        spritesheet: "/sprites/items/consumables/farming/beet.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    blueberry: {
        key: "blueberry",
        spritesheet: "/sprites/items/consumables/farming/blueberry.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    broccoli: {
        key: "broccoli",
        spritesheet: "/sprites/items/consumables/farming/broccoli.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    cabbage: {
        key: "cabbage",
        spritesheet: "/sprites/items/consumables/farming/cabbage.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    carrot: {
        key: "carrot",
        spritesheet: "/sprites/items/consumables/farming/carrot.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    corn: {
        key: "corn",
        spritesheet: "/sprites/items/consumables/farming/corn.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    cucumber: {
        key: "cucumber",
        spritesheet: "/sprites/items/consumables/farming/cucumber.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    onion: {
        key: "onion",
        spritesheet: "/sprites/items/consumables/farming/onion.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    pea: {
        key: "pea",
        spritesheet: "/sprites/items/consumables/farming/pea.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    potato: {
        key: "potato",
        spritesheet: "/sprites/items/consumables/farming/potato.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    pumpkin: {
        key: "pumpkin",
        spritesheet: "/sprites/items/consumables/farming/pumpkin.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    spinach: {
        key: "spinach",
        spritesheet: "/sprites/items/consumables/farming/spinach.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    strawberry: {
        key: "strawberry",
        spritesheet: "/sprites/items/consumables/farming/strawberry.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    tomato: {
        key: "tomato",
        spritesheet: "/sprites/items/consumables/farming/tomato.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    },
    wheat: {
        key: "wheat",
        spritesheet: "/sprites/items/consumables/farming/wheat.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 32
        }
    }
}

export const WEAPON_SPRITE_CONFIGS = {
    weapon_bow_basic: {
        key: "weapon_bow_basic",
        spritesheet: "/sprites/ui/weapons/bow.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 16
        }
    }
}


export const MOB_SPRITE_CONFIGS = {
    zombie: {
        key: "zombie",
        spritesheet: "/sprites/mobs/Zombie.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    bomb_zombie: {
        key: "bomb_zombie",
        spritesheet: "/sprites/mobs/BombZombie.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    dummy: {
        key: "dummy",
        spritesheet: "/sprites/mobs/Dummy.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    jump_zombie: {
        key: "jump_zombie",
        spritesheet: "/sprites/mobs/JumpZombie.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    poison_zombie: {
        key: "poison_zombie",
        spritesheet: "/sprites/mobs/PoisonZombie.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    poison_zombie_projectile: {
        key: "poison_zombie_projectile",
        spritesheet: "/sprites/mobs/PoisonZombie_Projectile.png",
        frameConfig: {
            frameWidth: 11,
            frameHeight: 11
        }
    },
    tongue_zombie: {
        key: "tongue_zombie",
        spritesheet: "/sprites/mobs/TongueZombie.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    skeleton: {
        key: "skeleton",
        spritesheet: "/sprites/mobs/Skeleton.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    archer: {
        key: "archer",
        spritesheet: "/sprites/mobs/Archer.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    skeleton_archer_projectile: {
        key: "skeleton_archer_projectile",
        spritesheet: "/sprites/mobs/SkeletonArcher_Arrow.png",
        frameConfig: {
            frameWidth: 5,
            frameHeight: 11
        }
    },
    skeleton_infantry: {
        key: "skeleton_infantry",
        spritesheet: "/sprites/mobs/SkeletonInfantry.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
    skeleton_knight: {
        key: "skeleton_knight",
        spritesheet: "/sprites/mobs/SkeletonKnight.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }   
    },
    skeleton_spearman: {
        key: "skeleton_spearman",
        spritesheet: "/sprites/mobs/SkeletonSpearman.png",
        frameConfig: {
            frameWidth: 48,
            frameHeight: 48
        }
    },
}

export const MOB_ANIMATION_CONFIGS = {
    // DUMMY ANIMATIONS
    dummy_birth: {
        key: "dummy_birth",
        frames: {
            spriteKey: "dummy",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    dummy_idle: {
        key: "dummy_idle",
        frames: {
            spriteKey: "dummy",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    dummy_walk: {
        key: "dummy_walk",
        frames: {
            spriteKey: "dummy",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    dummy_jump: {
        key: "dummy_jump",
        frames: {
            spriteKey: "dummy",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    dummy_fall: {
        key: "dummy_fall",
        frames: {
            spriteKey: "dummy",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    dummy_attack: {
        key: "dummy_attack",
        frames: {
            spriteKey: "dummy",
            frames: [26,27,28,29,30,31,32,33,34]
        },  
        frameRate: 8,
        repeat: 0
    },
    dummy_hurt: {
        key: "dummy_hurt",
        frames: {
            spriteKey: "dummy",
            frames: [35, 36, 37, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    dummy_death: {
        key: "dummy_death",
        frames: {
            spriteKey: "dummy",
            frames: [40, 41, 42, 43, 44, 45]
        },  
        frameRate: 8,
        repeat: 0
    },
    // ZOMBIE ANIMATIONS
    zombie_birth: {
        key: "zombie_birth",
        frames: {
            spriteKey: "zombie",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    zombie_idle: {
        key: "zombie_idle",
        frames: {
            spriteKey: "zombie",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    zombie_walk: {
        key: "zombie_walk",
        frames: {
            spriteKey: "zombie",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    zombie_jump: {
        key: "zombie_jump",
        frames: {
            spriteKey: "zombie",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    zombie_fall: {
        key: "zombie_fall",
        frames: {
            spriteKey: "zombie",
            frames: [25]
        },  
        frameRate: 8,
        repeat: -1
    },
    zombie_attack: {
        key: "zombie_attack",
        frames: {
            spriteKey: "zombie",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    zombie_hurt: {
        key: "zombie_hurt",
        frames: {
            spriteKey: "zombie",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    zombie_death: {
        key: "zombie_death",
        frames: {
            spriteKey: "zombie",
            frames: [40, 41, 42, 43, 44, 45]
        },  
        frameRate: 8,
        repeat: 0
    },
    // BOMB ZOMBIE ANIMATIONS
    bomb_zombie_birth: {
        key: "bomb_zombie_birth",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [0,1,2,3,4,5,6,7,8]
        },  
        frameRate: 8,
        repeat: 0
    },
    bomb_zombie_idle: {
        key: "bomb_zombie_idle",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [9,10,11,12,13]
        },      
        frameRate: 8,
        repeat: -1
    },
    bomb_zombie_walk: {
        key: "bomb_zombie_walk",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [14,15,16,17,18,19,20,21]
        },      
        frameRate: 8,
        repeat: -1
    },  
    bomb_zombie_jump: {
        key: "bomb_zombie_jump",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [22,23,24]
        },  
        frameRate: 8,
        repeat: 0
    },
    bomb_zombie_fall: {
        key: "bomb_zombie_fall",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [25]
        },  
        frameRate: 8,
        repeat: -1
    },
    bomb_zombie_attack: {
        key: "bomb_zombie_attack",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [26,27,28,29,30,31,32,33,34]
        }, 
        frameRate: 8,
        repeat: 0
    },
    bomb_zombie_hurt: {
        key: "bomb_zombie_hurt",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },  
    bomb_zombie_death: {
        key: "bomb_zombie_death",
        frames: {
            spriteKey: "bomb_zombie",
            frames: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56]
        },
        frameRate: 8,
        repeat: 0
    },
    // JUMP ZOMBIE ANIMATIONS
    jump_zombie_birth: {
        key: "jump_zombie_birth",
        frames: {
            spriteKey: "jump_zombie",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    jump_zombie_idle: {
        key: "jump_zombie_idle",
        frames: {
            spriteKey: "jump_zombie",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    jump_zombie_walk: {
        key: "jump_zombie_walk",
        frames: {
            spriteKey: "jump_zombie",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    jump_zombie_jump: {
        key: "jump_zombie_jump",
        frames: {
            spriteKey: "jump_zombie",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    jump_zombie_fall: {
        key: "jump_zombie_fall",
        frames: {
            spriteKey: "jump_zombie",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    jump_zombie_attack: {
        key: "jump_zombie_attack",
        frames: {
            spriteKey: "jump_zombie",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    jump_zombie_hurt: {
        key: "jump_zombie_hurt",
        frames: {
            spriteKey: "jump_zombie",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    jump_zombie_death: {
        key: "jump_zombie_death",
        frames: {
            spriteKey: "jump_zombie",
            frames: [40, 41, 42, 43, 44, 45]
        },
        frameRate: 8,
        repeat: 0
    },
    // POISON ZOMBIE ANIMATIONS
    poison_zombie_birth: {
        key: "poison_zombie_birth",
        frames: {
            spriteKey: "poison_zombie",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    poison_zombie_idle: {
        key: "poison_zombie_idle",
        frames: {
            spriteKey: "poison_zombie",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    poison_zombie_walk: {
        key: "poison_zombie_walk",
        frames: {
            spriteKey: "poison_zombie",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    poison_zombie_jump: {
        key: "poison_zombie_jump",
        frames: {
            spriteKey: "poison_zombie",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    poison_zombie_fall: {
        key: "poison_zombie_fall",
        frames: {
            spriteKey: "poison_zombie",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    poison_zombie_attack: {
        key: "poison_zombie_attack",
        frames: {
            spriteKey: "poison_zombie",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    poison_zombie_hurt: {
        key: "poison_zombie_hurt",
        frames: {
            spriteKey: "poison_zombie",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    poison_zombie_death: {
        key: "poison_zombie_death",
        frames: {
            spriteKey: "poison_zombie",
            frames: [40, 41, 42, 43, 44, 45]
        },
        frameRate: 8,
        repeat: 0
    },
    poison_zombie_projectile_move: {
        key: "poison_zombie_projectile_move",
        frames: {
            spriteKey: "poison_zombie_projectile",
            frames: [0,1,2]
        },
        frameRate: 8,
        repeat: 0
    },
    // SKELETON ANIMATIONS
    skeleton_birth: {
        key: "skeleton_birth",
        frames: {
            spriteKey: "skeleton",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_idle: {
        key: "skeleton_idle",
        frames: {
            spriteKey: "skeleton",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_walk: {    
        key: "skeleton_walk",
        frames: {
            spriteKey: "skeleton",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_jump: {
        key: "skeleton_jump",
        frames: {
            spriteKey: "skeleton",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_fall: {
        key: "skeleton_fall",
        frames: {
            spriteKey: "skeleton",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_attack: {
        key: "skeleton_attack",
        frames: {
            spriteKey: "skeleton",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_hurt: {
        key: "skeleton_hurt",
        frames: {
            spriteKey: "skeleton",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_death: {
        key: "skeleton_death",
        frames: {
            spriteKey: "skeleton",
            frames: [40, 41, 42, 43, 44, 45]
        },
        frameRate: 8,
        repeat: 0
    },
    // SKELETON ARCHER ANIMATIONS
    skeleton_archer_birth: {
        key: "skeleton_archer_birth",
        frames: {
            spriteKey: "archer",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_archer_idle: {
        key: "skeleton_archer_idle",
        frames: {
            spriteKey: "archer",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_archer_walk: {
        key: "skeleton_archer_walk",
        frames: {
            spriteKey: "archer",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_archer_jump: {
        key: "skeleton_archer_jump",
        frames: {
            spriteKey: "archer",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_archer_fall: {
        key: "skeleton_archer_fall",
        frames: {
            spriteKey: "archer",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_archer_attack: {
        key: "skeleton_archer_attack",
        frames: {
            spriteKey: "archer",
            frames: [26, 27, 28, 29, 30, 31, 32, 33]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_archer_hurt: {
        key: "skeleton_archer_hurt",
        frames: {
            spriteKey: "archer",
            frames: [34,35,36,37,38]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_archer_death: {
        key: "skeleton_archer_death",
        frames: {
            spriteKey: "archer",
            frames: [39,40,41,42,43,44]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_infantry_birth: {
        key: "skeleton_infantry_birth",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_infantry_idle: {
        key: "skeleton_infantry_idle",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_infantry_walk: {
        key: "skeleton_infantry_walk",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_infantry_jump: {
        key: "skeleton_infantry_jump",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_infantry_fall: {
        key: "skeleton_infantry_fall",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_infantry_attack: {
        key: "skeleton_infantry_attack",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_infantry_hurt: {
        key: "skeleton_infantry_hurt",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [35, 36, 37, 38, 39]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_infantry_death: {
        key: "skeleton_infantry_death",
        frames: {
            spriteKey: "skeleton_infantry",
            frames: [40, 41, 42, 43, 44, 45]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_spearman_birth: {
        key: "skeleton_spearman_birth",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_spearman_idle: {
        key: "skeleton_spearman_idle",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_spearman_walk: {
        key: "skeleton_spearman_walk",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_spearman_jump: {
        key: "skeleton_spearman_jump",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_spearman_fall: {
        key: "skeleton_spearman_fall",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_spearman_attack: {
        key: "skeleton_spearman_attack",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [26,27,28,29,30,31,32,33,34,35,36,37,38]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_spearman_hurt: {
        key: "skeleton_spearman_hurt",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [39, 40, 41, 42, 43]
            },
        frameRate: 8,
        repeat: 0
    },
    skeleton_spearman_death: {
        key: "skeleton_spearman_death",
        frames: {
            spriteKey: "skeleton_spearman",
            frames: [44, 45, 46, 47, 48, 49]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_birth: {
        key: "skeleton_knight_birth",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [0,1,2,3,4,5,6,7,8]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_idle: {
        key: "skeleton_knight_idle",
        frames: {
            spriteKey: "skeleton_knight",   
            frames: [9,10,11,12,13]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_knight_walk: {
        key: "skeleton_knight_walk",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [14,15,16,17,18,19,20,21]
        },
        frameRate: 8,
        repeat: -1
    },
    skeleton_knight_jump: {
        key: "skeleton_knight_jump",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [22,23,24]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_fall: {
        key: "skeleton_knight_fall",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [25]
        },
        frameRate: 8,
        repeat: -1,
    },
    skeleton_knight_attack: {
        key: "skeleton_knight_attack",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [26,27,28,29,30,31,32,33,34]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_skill: {
        key: "skeleton_knight_skill",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [35, 36, 37, 38, 39, 40, 41, 42, 43]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_hurt: {
        key: "skeleton_knight_hurt",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [44, 45, 46, 47, 48]
        },
        frameRate: 8,
        repeat: 0
    },
    skeleton_knight_death: {    
        key: "skeleton_knight_death",
        frames: {
            spriteKey: "skeleton_knight",
            frames: [49, 50, 51, 52, 53, 54, ]
        },
        frameRate: 8,
        repeat: 0
    }
}

export const WEAPON_ANIMATION_CONFIGS = {
    weapon_bow_basic_draw: {
        key: "weapon_bow_basic",
        frames: {
            spriteKey: "weapon_bow_basic",
            frames: [0,1,2,3,4,5]
        },
        frameRate: 8,
        repeat: 0
    }
}


// frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63]

export const FISHING_SPRITE_CONFIGS = {
    fishingRod: {
        key: "fishingRod",
        spritesheet: "/sprites/items/fishingRod.png",
        frameConfig: {
            frameWidth: 160,
            frameHeight: 90
        }
    },
    ripple: {
        key: "ripple",
        spritesheet: "/sprites/fishing/ripple.png",
        frameConfig: {
            frameWidth: 96,
            frameHeight: 6
        }
    },
    bobberFloating: {
        key: "bobberFloating",
        spritesheet: "/sprites/fishing/bobberFloating.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 24
        }
    },
    bobberBite: {
        key: "bobberBite",
        spritesheet: "/sprites/fishing/bobberBite.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 24
        }
    }
}
export const GENERIC_SPRITE_CONFIGS = {
    sparkle: {
        key: "sparkle",
        spritesheet: "/sprites/farming/sparkle_16x16.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 16
        }
    },
    mutant_sparkle: {
        key: "mutant_sparkle",
        spritesheet: "/sprites/farming/mutant_sparkle_16x16.png",
        frameConfig: {
            frameWidth: 16,
            frameHeight: 16
        }
    }
}

export const GENERIC_ANIMATION_CONFIGS = {
    sparkle: {
        key: "sparkle",
        frames: {
            spriteKey: "sparkle",
            frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14]
        },
        frameRate: 8,
        repeat: -1
    },
    mutant_sparkle: {
        key: "mutant_sparkle",
        frames: {
            spriteKey: "mutant_sparkle",
            frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14]
        },
        frameRate: 8,
        repeat: -1
    }
}

export const FISHING_ANIMATION_CONFIGS = {
    rod: {
        key: "rod",
        frames: {
            spriteKey: "fishingRod",
            frames: [0,1,2,3]
        },
        frameRate: 8,
        repeat: 0
    },
    ripple: {
        key: "ripple",
        frames: {
            spriteKey: "ripple",
            frames: [0,1,2,3,4,5]
        },
        frameRate: 8,
        repeat: 0
    },
    bobberFloating: {
        key: "bobberFloating",
        frames: {
            spriteKey: "bobberFloating",
            frames: [0,1,2,3]
        },
        frameRate: 8,
        repeat: 0
    },
    bobberBite: {
        key: "bobberBite",
        frames: {
            spriteKey: "bobberBite",
            frames: [0,1,2,3]
        },
        frameRate: 8,
        repeat: 0
    },
}

export const UI_SPRITE_CONFIGS = {
    cooldown_timer: {
        key: "cooldown_timer",
        spritesheet: "/sprites/ui/tools/cooldown-timer.png",
        frameConfig: {
            frameWidth: 58,
            frameHeight: 6
        }
    }
}

export const UI_ANIMATION_CONFIGS = {
    combat_cooldown: {
        key: "combat_cooldown",
        frames: {
            spriteKey: "cooldown_timer",
            frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]
        },
        frameRate: 8,
        repeat: -1
    }
}

export function loadUISprites(scene) {
    Object.values(UI_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}


export function loadGenericSprites(scene) {
    Object.values(GENERIC_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function loadSceneSprites(scene) {
    Object.values(SCENE_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function loadWeaponSprites(scene) {
    Object.values(WEAPON_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}
 
export function loadSolagotchiSprites(scene) {
    Object.values(SOLAGOTCHI_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function loadStatSprites(scene) {
    Object.values(STAT_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function loadFishingSprites(scene) {
    try {
        Object.values(FISHING_SPRITE_CONFIGS).forEach(config => {
            scene.load.spritesheet(
                config.key,
                config.spritesheet,
                config.frameConfig
            );
        });
    } catch (error) {
        console.error('Error loading fishing sprites:', error);
    }
}

export function loadMobSprites(scene) {
    Object.values(MOB_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function createSceneAnimations(scene) {
    Object.values(SCENE_ANIMATION_CONFIGS).forEach(config => {
        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

export function createSolagotchiAnimations(scene) {
    Object.values(SOLAGOTCHI_ANIMATION_CONFIGS).forEach(config => {
        try {
            // Skip if animation already exists
            if (scene.anims.exists(config.key)) {
                return;
            }

            scene.anims.create({
                key: config.key,
                frames: scene.anims.generateFrameNumbers(
                    config.frames.spriteKey,
                    { frames: config.frames.frames }
                ),
                frameRate: config.frameRate,
                repeat: config.repeat
            });
        } catch (error) {
            console.error(`Failed to create animation ${config.key}:`, error);
        }
    });
}

export function createStatAnimations(scene) {
    Object.values(STAT_ANIMATION_CONFIGS).forEach(config => {
        // Skip if animation already exists
        if (scene.anims.exists(config.key)) {
            return;
        }

        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

export function createMobAnimations(scene) {
    Object.values(MOB_ANIMATION_CONFIGS).forEach(config => {
        try {
            scene.anims.create({
                key: config.key,
                frames: scene.anims.generateFrameNumbers(
                    config.frames.spriteKey,
                    { frames: config.frames.frames }
                ),
                frameRate: config.frameRate,
                repeat: config.repeat
            });
        } catch (error) {
            console.error(`Failed to create mob animation ${config.key}:`, error);
        }
    });
}

export function createFishingAnimations(scene) {
    Object.values(FISHING_ANIMATION_CONFIGS).forEach(config => {
        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

export function loadChestSprites(scene) {

    Object.values(CHEST_SPRITE_CONFIGS).forEach(config => {

        try {
            // TEMPORARY: Load as image to test if file is accessible
            scene.load.image(config.key + '_debug', config.spritesheet);

            scene.load.once('filecomplete-image-' + config.key + '_debug', (_key, _type, texture) => {

                // Now try loading as spritesheet
                scene.load.spritesheet(
                    config.key,
                    config.spritesheet,
                    config.frameConfig
                );
                scene.load.start();
            });

            scene.load.once('loaderror', (fileObj) => {
                if (fileObj.key === config.key + '_debug') {
                    console.error('❌ Chest image file not accessible:', fileObj);
                }
            });
        } catch (error) {
            console.error('❌ Exception loading chest sprites:', error);
        }
    });
}

export function loadCropSprites(scene) {
    Object.values(CROP_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function createChestAnimations(scene) {
    Object.values(CHEST_ANIMATION_CONFIGS).forEach(config => {
        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

export function loadPlotSignSprites(scene) {
    Object.values(PLOT_SIGN_SPRITE_CONFIGS).forEach(config => {
        scene.load.spritesheet(
            config.key,
            config.spritesheet,
            config.frameConfig
        );
    });
}

export function createPlotSignAnimations(scene) {
    Object.values(PLOT_SIGN_ANIMATION_CONFIGS).forEach(config => {
        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

export function createGenericAnimations(scene) {
    Object.values(GENERIC_ANIMATION_CONFIGS).forEach(config => {
        scene.anims.create({
            key: config.key,
            frames: scene.anims.generateFrameNumbers(
                config.frames.spriteKey,
                { frames: config.frames.frames }
            ),
            frameRate: config.frameRate,
            repeat: config.repeat
        });
    });
}

// Helper function to play animations
export function playAnimation(sprite, animationKey, ignoreIfPlaying = true) {
    sprite.play(animationKey, ignoreIfPlaying);
}